import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./BulkNotificatio.module.css";
import companyStore from "../../../../Store/Store";

const Notificatio = ({
  completeData,
  incompleteData,
  isVisible,
  duplicateUsers,
  onClose,
  className = "",
}) => {
  const navigate = useNavigate();

  const onXCircleIconClick = useCallback(() => {
    navigate("/content/users");
  }, [navigate]);

  // if(!isVisible) return null
  return (
    <div className={[styles.frameParent, className].join(" ")}>
      <div className={styles.containerNotifi}>
        <div className={styles.httpslottiefilescomanimatParent}>
          <div className={styles.httpslottiefilescontent}>
            <div className={styles.httpslottiefilescontent1}>
              {completeData}
              <img
                className={styles.plusCircleIconHeading}
                alt=""
                src="/check-circle.svg"
              />
            </div>
            <div className={styles.plusCircleIcontext}>
              Users added successfully
            </div>
          </div>
          {duplicateUsers > 0 && (
            <div className={styles.httpslottiefilescontent}>
              <div className={styles.httpslottiefilescontent1}>
                {duplicateUsers}
                <img
                  className={styles.plusCircleIconHeading}
                  alt=""
                  src="/x-circle.svg"
                />
              </div>
              <div className={styles.plusCircleIcontext}>
                Users skipped as they already exist
              </div>
            </div>
          )}
        </div>
        <button
          className={styles.userAddedSuccessfullyBtn}
          onClick={() => {
            onXCircleIconClick();
          }}
        >
          Return to User management
        </button>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

Notificatio.propTypes = {
  className: PropTypes.string,
};

export default Notificatio;
